















import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { Element } from 'types';
import { mapGetters } from 'stores';
import { DRAG_LIBRARY, DRAG_DISTANCE } from 'constants/drag';
import AnimationManager from 'managers/animation.manager';
import DragManager from 'managers/drag.manager';
import iconUrl from 'helpers/icons';
import Draggable from 'models/draggable';

type ComponentCustom = {
  draggable: Draggable | null,
  startedDragId: string | null,
  $refs: {
    element: HTMLDivElement,
    icon: HTMLElement,
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'library-box',
  props: {
    element: Object as PropType<Element>,
  },
  data: () => ({
    animated: false,
  }),
  computed: {
    ...mapGetters([
      'elementIsExhausted',
      'isExhaustedForIdActive',
    ]),
    iconUrl(): string {
      return iconUrl(this.element.id);
    },
    name(): Element['name'] {
      return this.element.name;
    },
    isExhausted(): boolean {
      return !!this.elementIsExhausted(this.element.id);
    },
    ifAnimateExhausted(): boolean {
      return this.isExhausted && this.isExhaustedForIdActive(this.element.id);
    },
    classes(): Record<string, boolean> {
      return {
        'js-exhausted': this.isExhausted,
        'js-animate': this.ifAnimateExhausted,
      };
    },
  },
  mounted() {
    this.initDraggable();
  },
  beforeDestroy() {
    if (!this.draggable) return;

    this.draggable.destroy();
    this.draggable = null;
  },
  methods: {
    initDraggable() {
      this.draggable = new Draggable(this.$refs.element, {
        handle: [this.$refs.icon],
        type: DRAG_LIBRARY,
        dragDistance: DRAG_DISTANCE,
      });

      this.startedDragId = null;
      this.draggable.onDistanceDragged = (...args: any[]) => {
        if (this.isExhausted) return;

        (DragManager.onLibraryDistanceDragged as any)(this.startedDragId, ...args);
      };

      this.draggable.onLibraryDragStart = () => {
        this.startedDragId = this.element.id;
      };
    },
    onClick() {
      if (!this.isExhausted) return;

      AnimationManager.startExhausted(this.element.id);
    },
  },
});
